import { generatePath, Redirect, Route } from 'react-router-dom';

// Old paths kept working after a rename, because links already sent in
// e-mails point at them. Route parameters, the query string and the hash are
// carried over to the new path.
export const LEGACY_REDIRECTS: Array<{ from: string; to: string }> = [
  { from: '/businesstrips', to: '/trips' },
];

export const renderLegacyRedirects = () =>
  LEGACY_REDIRECTS.map(({ from, to }) => (
    <Route
      key={`redirect-${from}`}
      exact
      path={from}
      render={({ location, match }) => (
        <Redirect
          to={{
            pathname: generatePath(to, match.params),
            search: location.search,
            hash: location.hash,
          }}
        />
      )}
    />
  ));
